<style>

.container{
  font-size: 21px;
  display: grid;
  /* grid-template-columns: 110px; */
}
/* .stars{
  grid-column: 1;
}
.reviews{
  grid-column: 2;
  font-size: 18px;
} */
.reviews{
  display: inline;
  margin-top: -5px;
  font-size: 25px;
}
.large-stars{
  font-size: 30px;
}
</style>

<div class="container">

  <div class="stars">
    {#each items as item, index}
      {#if item == 1}
        <i class="icon-star {largeStars ? 'large-stars' : ''}" on:click="{ () => starClick(index) }"></i>
      {:else if item == 2}
        <i class="icon-star_half {largeStars ? 'large-stars' : ''}" on:click="{ () => starClick(index) }"></i>
      {:else}
        <i class="icon-star_outline {largeStars ? 'large-stars' : ''}" on:click="{ () => starClick(index) }"></i>
      {/if}
    {/each}
    
  </div>
  
  <div class="reviews">
    {#if reviews >= 0}
      <!-- ({reviews}) {text} -->
    {/if}
  </div>
  
</div>


<script>

export let stars = 4.5;
export let reviews = 250;
export let text = "";
export let largeStars = true;
export let readWrite = false;

let items = [0,0,0,0,0];

$:{
  if (stars) {
    items = [0,0,0,0,0];
    
    let pos = 0;
    for ( let i = stars; i > 0; i-=1.0 ) {
      
      if (i >= 1) {
        items[pos] = 1;
      } else {
        items[pos] = 2;
      }
      
      pos++;
    }
  }
}


function starClick(index) {
  console.log("index:", index);
  if (readWrite == true) {
    stars = index + 1;
  }
}


</script>